<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <div class="red--text">{{ msg }}</div>
        <v-row>
          <v-col cols="12">
            <p class="headline mb-0">Select number of cell to balanced</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="name"
              label="Enter Name"
              required
              outlined
              dense
              type="text"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="email"
              label="Enter Email"
              required
              outlined
              dense
              type="email"
              :rules="[rules.required, rules.email]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              :items="roles"
              label=""
              outlined
              v-model="role"
              hide-details
              dense
            ></v-select>
          </v-col>

          <v-col cols="12" md="3">
            <v-btn
              color="primary"
              class="mr-4"
              :loading="loading"
              rounded
              @click="submit()"
            >
              Register
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "RegisterForm",
  props: ["method"],
  data: () => ({
    valid: true,
    loading: false,
    rules: {
      required: (v) => !!v || "Field is required",
      email: (v) => /.+@.+/.test(v) || "E-mail must be valid",
    },
    name: "",
    email: "",
    role: "admin",
    msg: "",
    roles: [
      { value: "admin", text: "Admin" },
      { value: "subAdmin", text: "Sub Admin" },
      { value: "user", text: "User" },
      { value: "mechanic", text: "Mechanic" },
    ],
  }),
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          await api.register(this.name, this.email, this.role);
          this.$toast.success(this.role + " Added successfully");
          this.loading = false;
          this.method();
          this.$refs.form.reset();
          setTimeout(() => {
            this.role = "admin";
          }, 0);
        } catch (error) {
          this.$toast.error("added failed");
          this.loading = false;
        }
      }
    },
  },
};
</script>